import { Page } from "@react-pdf/renderer";

const PdfPage = ({
  children,
  pageNumber,
  submittedBy,
  submittedDate,
  ...props
}) => (
  <Page
    size="A4"
    style={{
      flexDirection: "column",
      backgroundColor: "#ffffff",
      padding: 30,
      fontSize: 10,
    }}
    {...props}
  >
    {children}
  </Page>
);

export default PdfPage;
